import React from 'react'
import Button from '../../../Button/Button'
import Style from './AdminInfo.module.scss'

const AdminInfo = ({handleOk,Info,address,showAddress}) => {
    return (
        <div className={Style.componentHolder}>
            <div className={Style.infoHolder}>
     
                <div className={Style.row}>
                    <div className={Style.titleHolder}>
                        <p className={Style.titleName}>نام</p>
                    </div>
                    <div className={Style.contentHolder}>
                        <p className={Style.name}>{Info.first_name}</p>
                    </div>
                </div>
        
                <div className={Style.row}>
                    <div className={Style.titleHolder}>
                        <p className={Style.titleLname}>نام خانوادگی</p>
                    </div>
                    <div className={Style.contentHolder}>
                        <p className={Style.Lname}>{Info.last_name}</p> 
                    </div>
                </div>
        
                <div className={Style.row}>
                    <div className={Style.titleHolder}>
                        <p className={Style.titleEmail}>ایمیل</p>
                    </div>
                    <div className={Style.contentHolder}>
                        <p className={Style.email}>{Info.email ? Info.email :" !ایمیل وجود ندارد"}</p>
                    </div>
                </div>
        
                <div className={Style.row}>
                    <div className={Style.titleHolder}>
                        <p className={Style.titlePhone}>شماره تماس</p>
                    </div>
                    <div className={Style.contentHolder}>
                        <p className={Style.phone}>{Info.phone}</p>
                    </div>
                </div>
                {showAddress
                ?
                <div className={Style.row}>
                    <div className={Style.titleHolder}>
                        <p className={Style.titleAddress}>آدرس</p>
                    </div>
                    <div className={Style.contentHolder}>
                        <p className={Style.address}>{address}</p>
                    </div>
                </div>
                :
                null
                }
            
            </div>
            <Button Value={'تایید'} ClickHandler={handleOk} ClassBtn={"okBtn"}/>
        </div>
    )
}

export default AdminInfo